import { render, staticRenderFns } from "./Signup.List.vue?vue&type=template&id=b6881cac&"
import script from "./Signup.List.vue?vue&type=script&lang=js&"
export * from "./Signup.List.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports